(function () {
  function initCollectionFilters(root) {
    if (!root || root.dataset.kokiFiltersReady === 'true') return;
    root.dataset.kokiFiltersReady = 'true';
    var buttons = root.querySelectorAll('[data-koki-filter]');
    var cards = root.querySelectorAll('[data-koki-card]');
    var count = root.querySelector('[data-koki-count]');
    function update(filter) {
      var visible = 0;
      cards.forEach(function (card) {
        var category = card.getAttribute('data-koki-category') || 'other';
        var show = filter === 'all' || category === filter;
        card.hidden = !show;
        if (show) visible += 1;
      });
      buttons.forEach(function (button) {
        var active = button.getAttribute('data-koki-filter') === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (count) count.textContent = visible + ' product' + (visible === 1 ? '' : 's');
    }
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        update(button.getAttribute('data-koki-filter') || 'all');
      });
    });
    update('all');
  }
  function init() {
    document.querySelectorAll('[data-koki-collection]').forEach(initCollectionFilters);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (event) {
    initCollectionFilters(event.target.querySelector('[data-koki-collection]'));
  });
})();
